module.exports = {
    nullable: 'Required',
    maxLen: 'Length can not exceed {{length}}',
    minLen: 'Length can not be less than {{length}}',
    max: 'Can not be greater than {{number}}',
    min: 'Can not be less than {{number}}',
    number: 'Must be number',
    format: 'Format error',
    regexError: '{regex} is not a valid regex.'
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locale.en.js
// module id = 11
// module chunks = 0